const API_KEY = process.env.REACT_APP_TMDB_API_KEY;

const TRENDING_MOVIES_URL = `https://api.themoviedb.org/3/trending/movie/week?api_key=${API_KEY}`;
const TRENDING_TV_SHOWS_URL = `https://api.themoviedb.org/3/trending/tv/week?api_key=${API_KEY}`;

const MOVIE_GENRE_LIST_URL = `https://api.themoviedb.org/3/genre/movie/list?api_key=${API_KEY}&language=en-US`;
const TV_SHOW_GENRE_LIST_URL = `https://api.themoviedb.org/3/genre/tv/list?api_key=${API_KEY}&language=en-US`;

const MOVIE_URL = 'https://api.themoviedb.org/3/movie/';
const TV_SHOW_URL = 'https://api.themoviedb.org/3/tv/';

const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/';
const POSTER_SIZE = 'w500';

const IMDB_URL = 'https://www.imdb.com/title/';
const YOUTUBE_SEARCH_URL = 'https://www.youtube.com/results?search_query=';

export {
  API_KEY,
  TRENDING_MOVIES_URL,
  TRENDING_TV_SHOWS_URL,
  MOVIE_GENRE_LIST_URL,
  TV_SHOW_GENRE_LIST_URL,
  MOVIE_URL,
  TV_SHOW_URL,
  IMAGE_BASE_URL,
  POSTER_SIZE,
  IMDB_URL,
  YOUTUBE_SEARCH_URL,
};
